import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { Storage } from '@ionic/storage'

import { URL_SERVICIOS_LOCALES, URL_SERVICIOS_LOCALES_IMPRESORA, MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO } from '../../config/url.servicio'

@Injectable()
export class DomiciliosappProvider {
  token:string
  urlPrintService:string


  constructor(public http: Http, private storage:Storage) {
      this.storage.get('token').then((val) => {
          this.token = val
      });

      this.storage.get('urlPrint').then((val) => {
          this.urlPrintService = val
      });
  }

  buscarDomicilio(companiasId:any) {
      let url = URL_SERVICIOS_LOCALES
      return this.http.get(`${url}/proceso/buscarDomiciliosAppGruposLista?companiasId=${companiasId}`)
          .map((data) => data.json())
  }
//**cambiar nombre */
buscarDomiciliosAddGruposProductosContenido(companiasId:any) {
    let url = URL_SERVICIOS_LOCALES
    return this.http.get(`${url}/proceso/buscarDomiciliosAddGruposProductosContenido?companiasId=${companiasId}`)
        .map((data) => data.json())
}

buscargruposProductosDomiciliosDescripcion(domiciliosAddgruposUuid:any,domiciliosAddproductosUuid:any) {
    let url = URL_SERVICIOS_LOCALES


    return this.http.get(`${url}/proceso/buscarDomiciliosAddGruposProductosContenidoDescuentoInventario?domiciliosAddgruposUuid=${domiciliosAddgruposUuid}&domiciliosAddproductosUuid=${domiciliosAddproductosUuid}`)
        .map((data) => data.json())
}


}




// WEBPACK FOOTER //
// ./src/providers/domiciliosapp/domiciliosapp.ts